function initServicesAccordion() {
  const accordions = document.querySelectorAll(".accordion--services");

  accordions.forEach((accordion) => {
    const btn = accordion.querySelector(".accordion__btn");
    const arrow = accordion.querySelector(".accordion__arrow");
    const services = accordion.querySelector(".accordion__services");

    const toggleAccordion = () => {
      const active = accordion.classList.contains("active");

      if (active) {
        accordion.classList.remove("active");
        services.style.height = "0";
      } else {
        accordion.classList.add("active");

        services.style.height = "auto";
        const height = services.scrollHeight;
        services.style.height = "0";

        services.offsetHeight;
        services.style.height = height + "px";
        setTimeout(() => {
          if (accordion.classList.contains("active")) {
            services.style.height = "auto";
          }
        }, 300);
      }
    };

    btn.addEventListener("click", toggleAccordion);
    arrow.addEventListener("click", toggleAccordion);
  });
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initServicesAccordion);
} else {
  initServicesAccordion();
}
